import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LicenseInfo } from '@mui/x-license';
import App from './App';

// MUI X pro components (data grid, date pickers) need the license set once, before they render
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
